module.exports = __webpack_public_path__ + "img/right.b2386a54.svg";